import withPageContainer from '../shared/page-container/with-page-container';
import withIntl from '../shared/intl-hoc';

import { enum as permissions } from '../../../../../enums/admin-permissions';

const tabs = [
	{
		href: '/offer-location-rules/geo-rules',
		name: 'Geo rules',
		permission: null
	},
	{
		href: '/offer-location-rules/lang-rules',
		name: 'Lang rules',
		permission: null
	}
];

export default Main => withPageContainer(withIntl(Main), {
	name: 'Rules',
	tabs,
	permission: permissions.offersList
});


// WEBPACK FOOTER //
// ./frontend/admin-dashboard/src/modules/offer-location-rules/wrap-main.js